import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ExtraOptions, PreloadAllModules, RouterModule } from "@angular/router";
import { MarkdownModule } from "ngx-markdown";
import { FuseModule } from "@fuse";
import { FuseConfigModule } from "@fuse/services/config";
import { FuseMockApiModule } from "@fuse/lib/mock-api";
import { CoreModule } from "app/core/core.module";
import { appConfig } from "app/core/config/app.config";
import { mockApiServices } from "app/mock-api";
import { LayoutModule } from "app/layout/layout.module";
import { AppComponent } from "app/app.component";
import { appRoutes } from "app/app.routing";
import { FetchData, UserAccountMessages } from "app/shared/generalMethods";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { environment } from "../environments/environment";
import { ParentPortalService } from "./services/parentPortal.service";
import { AdminProgramService } from "app/services/admin-program.service";
import { AdminProfileService } from "./services/admin-profile.service";
import { FullCalendarModule } from "@fullcalendar/angular";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import adaptivePlugin from "@fullcalendar/adaptive";
import listPlugin from "@fullcalendar/list";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { MatTableModule } from "@angular/material/table";
import { InputValidation } from "./shared/inputValidation";
import { MatDialogModule } from "@angular/material/dialog";
import { MaintenanceComponent } from "./modules/auth/maintenance/maintenance.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { CreateProgramComponent } from "./modules/admin/programs/create-program/create-program.component";
import { AdminDashboardComponent } from "./modules/admin/admin-dashboard/admin-dashboard.component";
import { AttendanceStudentComponent } from "./modules/admin/admin-dashboard/attendance-student/attendance-student.component";
import { AdminProfileComponent } from "./modules/admin/admin-dashboard/admin-profile/admin-profile.component";
import { CreateCommunityComponent } from "./modules/admin/admin-dashboard/create-community/create-community.component";
import { AdminDetailComponent } from "./modules/admin/admin-dashboard/admin-detail/admin-detail.component";
import { ProgramDetailComponent } from "./modules/admin/programs/program-detail/program-detail.component";
import { CommunityListComponent } from "./modules/admin/admin-dashboard/community-list/community-list.component";
import { CommunityDetailComponent } from "./modules/admin/admin-dashboard/community-detail/community-detail.component";
import { ProgramsListComponent } from "./modules/admin/programs/programs-list/programs-list.component";

import { AdminCommunityService } from "./services/admin-community.service";
import { AdminMembershipFormComponent } from "./modules/admin/admin-dashboard/admin-membership-form/admin-membership-form.component";
import { StaffFormComponent } from "./modules/admin/staff-profile/staff-form/staff-form.component";
import { StaffDetailComponent } from "./modules/admin/staff-profile/staff-detail/staff-detail.component";
import { StaffService } from "./services/staff.service";
import { AdminReportsComponent } from "./modules/admin/admin-dashboard/admin-reports/admin-reports.component";
import { AttendanceDetailComponent } from "./modules/admin/admin-dashboard/attendance-detail/attendance-detail.component";
import { AttendanceService } from "./services/attendance.service";
import { OrganizationComponent } from "./modules/admin/organization/organization.component";

FullCalendarModule.registerPlugins([
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin,
  resourceTimeGridPlugin,
  adaptivePlugin,
  listPlugin,
  resourceTimelinePlugin,
]);

const routerConfig: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: "enabled",
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    MatTableModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),
    FullCalendarModule,
    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),

    //Firebase
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,

    MatDialogModule,

    MatIconModule,
    MatButtonModule,
  ],

  // eslint-disable-next-line max-len
  providers: [
    ParentPortalService,
    AdminProgramService,
    StaffService,
    AdminProfileService,
    UserAccountMessages,
    FetchData,
    InputValidation,
    MaintenanceComponent,
    CreateProgramComponent,
    AdminDashboardComponent,
    AttendanceStudentComponent,
    AdminProfileComponent,
    CreateCommunityComponent,
    AdminDetailComponent,
    ProgramDetailComponent,
    CommunityDetailComponent,
    ProgramsListComponent,
    CommunityListComponent,
    AdminCommunityService,
    AdminMembershipFormComponent,
    StaffFormComponent,
    StaffDetailComponent,
    AdminReportsComponent,
    AttendanceDetailComponent,
    AttendanceService,
    OrganizationComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
